import { Injectable } from "@angular/core";
import { loadScript, PlatformService } from "@obg/ngx.global";
import { CookieService, DocumentRef } from "@obg/ngx.global.evo";
import { addYears } from "date-fns";

import { DataProtectionConfigService } from "../data-protection.config";

import { CookieConsentConfigService } from "./cookie-consent.config";
import { CONSENT_COOKIE_NAME } from "./cookie-consent.const";
import { ConsentCookie } from "./cookie-consent.model";

@Injectable({
	providedIn: "root",
})
export class CookieConsentService {
	constructor(
		private cookieService: CookieService,
		private config: DataProtectionConfigService,
		private documentRef: DocumentRef,
		private cookieConsentConfigService: CookieConsentConfigService,
		private platformService: PlatformService
	) {}

	writeCookie(marketConsent: ConsentCookie) {
		this.cookieService.setJson({
			name: CONSENT_COOKIE_NAME,
			value: { ...marketConsent },
			domain: this.cookieConsentConfigService.getOneTrustCookieDomain(),
			expiryDate: addYears(new Date(), this.config.getCookieExpiryYears()),
			path: "/",
		});
	}

	readCookie(): ConsentCookie | undefined {
		return this.cookieService.getJson(CONSENT_COOKIE_NAME);
	}

	injectOneTrust(
		cdnUrl: string,
		domainScript: string,
		dataDocumentLanguage: boolean | undefined,
		dataLanguage: string | undefined
	) {
		if (this.platformService.isServer) {
			return;
		}

		const params = {
			src: cdnUrl,
			id: "oneTrust",
			attributes: {
				"data-document-language": dataDocumentLanguage ? "true" : "false",
				"data-domain-script": domainScript,
			} as Record<string, string>,
		};

		if (dataLanguage) {
			params.attributes["data-language"] = dataLanguage;
		}

		loadScript(params);

		const script = this.documentRef.native.createElement("script");
		script.append("function OptanonWrapper() { }");
		this.documentRef.native.head.appendChild(script);
	}
}
